/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activate_ButtonInputs */



/**
* | output |
* | --- |
* | "Activate License" |
*
* @param {Login_Offline_Activate_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activate_button = /** @type {((inputs?: Login_Offline_Activate_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activate_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer la Licence")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lizenz aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva licenza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активировать лицензию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar licencia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活许可证")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライセンスを有効化")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइसेंस सक्रिय करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar licença")
	return /** @type {LocalizedString} */ ("Activate License")
});